/* tslint:disable */

declare var Object: any;
export interface PropertySettlementInterface {
  "description": string;
  "collection_date": Date;
  "property_id": number;
  "total_collected": number;
  "total_bills": number;
  "status": string;
  "pending_invoices": any;
  "id"?: number;
  "landlord_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class PropertySettlement implements PropertySettlementInterface {
  "description": string;
  "collection_date": Date;
  "property_id": number;
  "total_collected": number;
  "total_bills": number;
  "status": string;
  "pending_invoices": any;
  "id": number;
  "landlord_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: PropertySettlementInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertySettlement`.
   */
  public static getModelName() {
    return "PropertySettlement";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertySettlement for dynamic purposes.
  **/
  public static factory(data: PropertySettlementInterface): PropertySettlement{
    return new PropertySettlement(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertySettlement',
      plural: 'PropertySettlements',
      path: 'PropertySettlements',
      idName: 'id',
      properties: {
        "description": {
          name: 'description',
          type: 'string'
        },
        "collection_date": {
          name: 'collection_date',
          type: 'Date'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "total_collected": {
          name: 'total_collected',
          type: 'number'
        },
        "total_bills": {
          name: 'total_bills',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'ACTIVE'
        },
        "pending_invoices": {
          name: 'pending_invoices',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "landlord_id": {
          name: 'landlord_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
